export default "__VITE_ASSET__i65ySsYc__"